import React, { Children } from "react";

interface ModalButtonsContainerProps {
  spaceBetween?: boolean;
  centerButtons?: boolean;
  children?: React.ReactNode;
  className?: string;
}

const ModalButtonsContainer: React.FC<ModalButtonsContainerProps> = ({
  spaceBetween,
  centerButtons,
  children,
  className,
}) => {
  const countArray = Children.toArray(children).length;
  return (
    <div
      className={`modal-buttons-container form-button-group ${
        spaceBetween ? "space-between" : ""
      } ${centerButtons ? "center-buttons" : ""} ${
        className ? className : ""
      } ${countArray >= 3 ? "has-3-btns" : ""}`}
    >
      {children}
    </div>
  );
};

export default ModalButtonsContainer;
